var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loaded && !_vm.isNdiBa
      ? _c(
          "div",
          [
            _c("analisar-validar-processo", {
              attrs: {
                responseAnalise: _vm.responseAnalise,
                processo: _vm.processo,
                hasAnalisePendente: _vm.hasAnalisePendente,
                idProcesso: _vm.idProcesso,
                acaoCaixa: _vm.acaoCaixa,
                regras: _vm.regras,
                active: _vm.active,
                analiseManual: _vm.analiseManual
              },
              on: { atualizarTela: _vm.atualizarTela, setActive: _vm.setActive }
            })
          ],
          1
        )
      : _vm._e(),
    _vm.loaded && _vm.isNdiBa
      ? _c(
          "div",
          [
            _c("emitir-certidao-area", {
              attrs: {
                regras: _vm.regras,
                processo: _vm.processo,
                idProcesso: _vm.idProcesso
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7ff2ed8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7ff2ed8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/AnalisarValidarProcessoDefault.vue
// module id = null
// module chunks = 